import { React, useState, useEffect, useRef } from 'react'

import { useDispatch } from 'react-redux';
import { addToCart } from '../../redux/cart.slice';
import { clearOrder } from '../../redux/order.slice';
import { clearShipping } from '../../redux/shipping.slice';
import { toggleCart } from '../../redux/minicart.slice';
import CurrencyFormat from 'react-currency-format'
import * as ga from '../../lib/ga'

import WishListButton from '../wishlist/button'

import Link from 'next/link'

function Price({ variation, item }) {

    const instock = (variation) => {
        if (variation.quantity > 0) {
            return true
        } else if (variation.backorder) {
            return true
        } else {
            return false
        }
    }

    const dispatch = useDispatch();

    const [stored_variation, set_stored_variation] = useState(variation)
    const [quantity_to_add, set_quantity_to_add] = useState(1)
    const [added_to_cart, set_added_to_cart] = useState(false)
    const [backorder_stock_check,set_backorder_stock_check] = useState(false)
    const incrementQuantityBtn = useRef(null)


    const set_quantity_and_price = (quantity_to_add) => {
        // set quantity
        set_quantity_to_add(Number(quantity_to_add))
        // take a copy of the state
        var change_variation = stored_variation
        // store the stock level for later
        change_variation.available_quantity = stored_variation.quantity
        change_variation.add_quantity = Number(quantity_to_add)
        // change prices if needed
        change_variation = change_price_based_on_discount_table(change_variation)
        // write it back
        set_stored_variation(change_variation)
    }


    const increment_quantity_to_add = (event) => {
        if (stored_variation.backorder == 1) {
            if (Number(quantity_to_add) >= 1 && Number(quantity_to_add) < 1000) {
                set_quantity_and_price(Number(quantity_to_add) + Number(1))
            }
            if (Number(quantity_to_add) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(quantity_to_add) >= 999) {
                set_quantity_and_price(999)
            }
        } else {
            if(Number(quantity_to_add) + Number(1)  == Number(stored_variation.quantity)){
                incrementQuantityBtn.current.disabled = true;
            }
            if (Number(quantity_to_add) >= Number(stored_variation.quantity)) {
                set_quantity_and_price(Number(stored_variation.quantity) + Number(1))
            }
            if (Number(quantity_to_add) >= 1 && Number(quantity_to_add) <= 1000) {
                set_quantity_and_price(Number(quantity_to_add) + Number(1))
            }
            if (Number(quantity_to_add) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(quantity_to_add) >= 999) {
                set_quantity_and_price(999)
            }
        }
    }

    const change_quantity_input = (event) => {
        if (stored_variation.backorder == 1) {
            if (Number(event.target.value) >= 1 && Number(event.target.value) < 1000) {
                set_quantity_and_price(Number(event.target.value))
            }
            if (Number(event.target.value) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(event.target.value) >= 1000) {
                set_quantity_and_price(999)
            }
        } else {
            if (Number(event.target.value) >= Number(quantity_to_add.quantity)) {
                set_quantity_and_price(Number(quantity_to_add.quantity))
            }
            if (Number(event.target.value) >= 1 && Number(event.target.value) < 1000) {
                set_quantity_and_price(Number(event.target.value))
            }
            if (Number(event.target.value) < 1) {
                set_quantity_and_price(1)
            }
            if (Number(event.target.value) >= 1000) {
                set_quantity_and_price(999)
            }
        }
    }

    const decrement_quantity_to_add = (event) => {
        if (stored_variation.backorder == 1) {
            if (Number(quantity_to_add) > 1 && Number(quantity_to_add) < 1000) {
                set_quantity_and_price(Number(quantity_to_add) - Number(1))
            }
            if (Number(quantity_to_add) <= 1) {
                set_quantity_and_price(1)
            }
            if (Number(quantity_to_add) >= 1000) {
                set_quantity_and_price(999)
            }
        } else {
            if (Number(quantity_to_add) >= Number(stored_variation.quantity)) {
                set_quantity_and_price(Number(stored_variation.quantity) - Number(1))
            }
            if (Number(quantity_to_add) > 1 && Number(quantity_to_add) < 1000) {
                incrementQuantityBtn.current.disabled = false;
                set_quantity_and_price(Number(quantity_to_add) - Number(1))
            }
            if (Number(quantity_to_add) <= 1) {
                set_quantity_and_price(1)
            }
            if (Number(quantity_to_add) >= 1000) {
                set_quantity_and_price(999)
            }
        }
    }



    const add_to_cart = (event, url,role) => {
        if (stored_variation.backorder == 0 && Number(quantity_to_add) > Number(stored_variation.quantity)) {
            set_backorder_stock_check(true)
        }else{
            set_backorder_stock_check(false)
            event.preventDefault()
            set_quantity_and_price(Number(quantity_to_add))

            stored_variation.url = url;
            stored_variation.role = role;

            // clear any pending orders they havent completed yet
            dispatch(clearOrder())
            dispatch(clearShipping())
            dispatch(addToCart(stored_variation))
            set_added_to_cart(true)
            dispatch(toggleCart())
            ga.add_to_cart(stored_variation)
        }
    }

    const multibuy_add_to_cart = (event, quantity, url,role) => {
        event.preventDefault()
        // this one needs coded in the function - otherwise it happens too late and it adds the previous value
        set_quantity_and_price(Number(quantity))

        stored_variation.url = url;
        stored_variation.role = role;

        // clear any pending orders they havent completed yet
        dispatch(clearOrder())
        dispatch(clearShipping())
        dispatch(addToCart(stored_variation))
        set_added_to_cart(true)
        ga.add_to_cart(stored_variation)
    }

    const change_price_based_on_discount_table = (passed_variation) => {
        if (passed_variation.stock_item_discount_table) {
            // sort the array descending, so that when I use findIndex it gets the largest number applicable
            var key_checker = Object.keys(passed_variation.stock_item_discount_table).sort((a, b) => b - a)
            // the quantity we want to add to our basket

            // check the object for our quantity
            var match = key_checker.findIndex((element) => element <= passed_variation.add_quantity)

            if (match >= 0) {
                var key = key_checker[match]
                // overwrite the values here
                passed_variation.price = passed_variation.stock_item_discount_table[key].price
                passed_variation.price_ex_vat = passed_variation.stock_item_discount_table[key].price_ex_vat
                passed_variation.price_inc_vat = passed_variation.stock_item_discount_table[key].price_inc_vat
            }
        }
        return passed_variation
    }

    useEffect(() => {
        set_stored_variation(variation)
    }, [variation])

    return (
        <>
        <div {...variation.sku == '520-388-0842' && {'data-nosnippet' : ''}}>
        {(stored_variation.variation_status == null || stored_variation.variation_status == '') ? (
            <>
            {(stored_variation.rrp && stored_variation.price_inc_vat && stored_variation.rrp > 0 && stored_variation.rrp > stored_variation.price_inc_vat) ? (
                <div className="old-price mb-4">
                    <div className="text-gray-900 text-xs font-bold">
                        WAS
                    </div>
                    <div className="text-gray-600 font-light line-through text-2xl leading-none">
                        <CurrencyFormat decimalScale={2} value={stored_variation.rrp / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                    </div>
                </div>
            ) : ('')}

            {/* in here, I need to adjust the pricing for that item if it has the discounts table */}
                    <div className="price flex items-end space-x-8 mb-6">
                    {(stored_variation.price_inc_vat && stored_variation.price_inc_vat > 0) ? (
                        <div>
                            {(stored_variation.rrp && stored_variation.rrp > 0 && stored_variation.rrp > stored_variation.price_inc_vat) ? (
                                <>
                                    <div className="text-gray-900 text-xs font-bold">
                                        NOW
                                    </div>
                                    <div className="text-rose-600 font-semibold text-3xl leading-none">
                                        <CurrencyFormat decimalScale={2} value={stored_variation.price_inc_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                    </div>
                                    <div className="text-gray-600 text-sm  font-medium">
                                        <small>INC. VAT</small>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="text-gray-900 font-semibold text-3xl leading-none">
                                        <CurrencyFormat decimalScale={2} value={stored_variation.price_inc_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                    </div>
                                    <div className="text-gray-600 text-sm  font-medium">
                                        <small>INC. VAT</small>
                                    </div>
                                </>
                            )}
                            </div>
                        ) : ('')}
                        {(stored_variation.price_ex_vat && stored_variation.price_ex_vat > 0) ? (
                            <div>
                                <div className="text-gray-900 font-medium text-2xl leading-none">
                                    <CurrencyFormat decimalScale={2} value={stored_variation.price_ex_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                </div>
                                <div className="text-gray-600 font-medium">
                                    <small>EX. VAT</small>
                                </div>
                            </div>
                        ) : ('')}
                    </div>
                </>
            ):('')}
            
            <div className="flex space-x-6 items-center mb-6">
                <div>
                    <span className="font-medium text-sm text-gray-900">Advanced Water Code:</span> <span className="font-bold text-sm text-gray-900 tracking-wider">{stored_variation.sku}</span>
                </div>
                <div>
                    <span className="font-medium text-sm text-gray-900">Manufacturer Code:</span> <span className="font-bold text-sm text-gray-900 tracking-wider">{stored_variation.mpn}</span>
                </div>
            </div>

            <div className="mb-4 border-b border-t border-gray-300 py-6">
            <div className="lg:flex lg:space-x-3">
                {instock(stored_variation) ? (
                    <>
                    {(stored_variation.variation_status == null || stored_variation.variation_status == '') ? (
                        <>
                        <div className="quantity flex lg:w-40 flex-grow-0 w-full mb-2 lg:mb-0">
                            <button
                                onClick={(event) => decrement_quantity_to_add(event)}
                                className="cursor-pointer rounded-tl rounded-bl bg-white flex items-center justify-center border-l border-t border-b border-gray-300 px-4 hover:bg-gray-100 active:bg-gray-200 focus:ring-2 focus:ring-brand-tertiary transition duration-150 ease-in-out"
                            >
                                <i className="fas fa-minus"></i>
                            </button>
                            <input
                                pattern="[0-9]+"
                                type="text"
                                onChange={(event) => change_quantity_input(event)}
                                className="appearance-none block w-full py-3 px-0 border border-gray-300 text-center text-gray-800 focus:not-italic p-4 hover:border-brand-secondary active:border-brand-tertiary transition-all focus:outline-none focus:border-brand-tertiary focus:ring-2 focus:ring-inset focus:ring-brand-tertiary"
                                value={quantity_to_add}
                            />
                            <button
                                onClick={(event) => increment_quantity_to_add(event)}
                                className="cursor-pointer rounded-tr rounded-br bg-white flex items-center justify-center border-r border-t border-b border-gray-300 px-4 hover:bg-gray-100 active:bg-gray-200 focus:ring-2 focus:ring-brand-tertiary transition duration-150 ease-in-out"
                                ref={incrementQuantityBtn}
                            >
                                <i className="fas fa-plus"></i>
                            </button>
                        </div>
                        {
                            (added_to_cart) ? (
                                <button
                                    onClick={(event) => add_to_cart(event,item.url, item.role)}
                                    className="btn btn-added-to-cart w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-1" width="16" height="16" viewBox="0 0 16 16">
                                        <path id="Path_149" data-name="Path 149" d="M7.667,10l1.556,1.556,3.111-3.111M17,10a7,7,0,1,1-7-7A7,7,0,0,1,17,10Z" transform="translate(-2 -2)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                    </svg>
                                    Added To Trolley
                                </button>
                            ) : (
                                <button
                                    onClick={(event) => add_to_cart(event,item.url, item.role)}
                                    className="btn btn-primary w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                    Add To Trolley
                                </button>
                            )
                        }
                        </>
                    ) : (
                        <>
                        {stored_variation.variation_status == 'Obsolete' ? (
                            <button
                                className="btn cursor-default bg-rose-600 w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                Obsolete
                            </button>
                        ) : ('')}
                        {stored_variation.variation_status == 'Superseded' ? (
                            <>
                                {stored_variation.superseded_by ? (
                                    <Link href=
                                    {
                                        stored_variation.superseded_by.role === 'merchant'
                                            ? `/merchant/product/${stored_variation.superseded_by.url}`
                                            : `/product/${stored_variation.superseded_by.url}`
                                    }
                                    >
                                    <a
                                        className="btn bg-rose-600 w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                        Superseded By {stored_variation.superseded_by.sku}
                                    </a>
                                    </Link>
                                ) : (
                                    <Link href="/replacement-coming-soon">
                                    <a
                                        className="btn bg-rose-600 w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                        Superseded By TBC
                                    </a>
                                    </Link>
                                )}
                            </>
                        ) : ('')}
                        {stored_variation.variation_status == 'Price On Application' ? (
                            <button
                                className="btn cursor-default bg-gray-500 w-full lg:w-auto mb-2 lg:mb-0 btn-lg flex-grow">
                                Price on Application
                            </button>
                        ) : ('')}
                        </>
                    )}
                    </>
                ) : (
                    <>
                        <div className="opacity-25 quantity flex lg:w-40 w-full mb-2 lg:mb-0">
                            <button disabled className="cursor-pointer rounded-tl rounded-bl bg-white flex items-center justify-center border-l border-t border-b border-gray-300 px-4">
                                <i className="fas fa-minus"></i>
                            </button>
                            <input disabled type="" name="" className="appearance-none block w-full py-3 px-0 border border-gray-300 font-extralight text-center" value="1" />
                            <button disabled className="cursor-pointer rounded-tr rounded-br bg-white flex items-center justify-center border-r border-t border-b border-gray-300 px-4">
                                <i className="fas fa-plus"></i>
                            </button>
                        </div>
                        <button
                            disabled
                            className="btn btn-disabled w-full lg:w-auto mb-2 lg:mb-0 flex flex-grow items-center px-4 py-2 text-white text-base justify-center font-semibold">
                            Out of Stock
                        </button>
                    </>
                )}

                <WishListButton product_id={stored_variation.product_id} url={item.url} is_fav={item.isFav}></WishListButton>
            </div>
            {(backorder_stock_check ? <a
                                        className="text-red-600 w-full lg:w-auto block mt-4">
                                        Please enter available stock quantity
                                    </a>:'')}
            </div>
            {(stored_variation.stock_item_discount_table) ? (
                <div className="flex flex-col mb-6">
                    <div><span className="font-bold text-sm text-gray-900">Multi-Buy Deals:</span></div>
                    <div className="lg:grid lg:grid-cols-3 lg:gap-2 space-y-2 lg:space-y-0">
                        {Object.keys(stored_variation.stock_item_discount_table).map((key) => (
                            <button
                                key={key}
                                className="border-2 border-aw-secondary rounded text-center leading-5 items-center justify-center font-semibold text-aw-secondary text-base py-4 flex flex-col"
                                onClick={(event) => multibuy_add_to_cart(event, stored_variation.stock_item_discount_table[key].quantity, item.url, item.role)}
                            >
                                Buy&nbsp;
                                {stored_variation.stock_item_discount_table[key].quantity} for<br />
                                <CurrencyFormat decimalScale={2} value={stored_variation.stock_item_discount_table[key].price_ex_vat / 100} displayType={'text'} thousandSeparator={true} prefix={'£'} fixedDecimalScale={true} />
                                (Ex. VAT) each
                            </button>
                        ))}
                    </div>
                </div>
            ) : ('')}

            <div>
                <i className="fas fa-question-circle text-brand-tertiary mr-2 "></i>
                <Link href={"/contact?part_number=" + stored_variation.sku}>
                    <a className="cursor-pointer">
                        <span className="font-semibold text-brand-primary underline hover:no-underline text-base">Got a question about this item?</span>
                    </a>
                </Link>
            </div>
        </div>
        </>


    );
}

export default Price;
